import Inputmask from "inputmask";
export default function initMasks() {
    document.querySelectorAll("[data-mask-phone]").forEach(input => Inputmask('+7 (999) 999 99 99').mask(input));
    document.querySelectorAll("[data-mask-card]").forEach(input => Inputmask('2  020999  999999').mask(input));
}

